<template>
  <div class="modal" :class="{'is-active': opened}">
    <div class="modal-background"></div>
    <div class="modal-card my-modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Create Item Receipts</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <article class="message is-warning" v-if="succeededReceipts.length && !done">
          <div class="message-header">
            <p>
              <span v-if="!deleting">Please make sure you have deleted previous created item receipts below before recreating new item receipts</span>
              <span v-if="deleting">
                <span>Confirming previously created item receipts deleted</span>&nbsp;
                <span class="icon">
                  <i class="fas fa-spinner fa-pulse"></i>
                </span>
              </span>
            </p>
          </div>
          <div class="message-body">
            <p v-for="(r, i) in succeededReceipts" :key="'vrs-'+i">
              {{ r }}
            </p>
          </div>
        </article>
        <table class="table is-fullwidth">
          <thead>
            <tr>
              <th>#</th>
              <th>Inbound Shipment</th>
              <th>PO</th>
              <th>Container</th>
              <th>Quantity</th>
              <th>Result</th>
              <th>NS result</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, j) in receipts" :key="'p-r-'+j">
              <td>{{j+1}}</td>
              <td>{{r.inboundId}}</td>
              <td>{{r.po.tranId}}</td>
              <td>{{r.container}}</td>
              <td>{{r.quantity}}</td>
              <td>
                <span class="tag" :class="{'is-warning': r.result.startsWith('Creating'), 'is-success': r.result.startsWith('Succeeded'), 'is-danger': r.result.startsWith('Failed')}">
                  {{r.result}}
                </span>
              </td>
              <td>{{r.nsResult}}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="error" class="notification is-danger is-light">
          <button class="delete" @click="error=''"></button>
          {{error}}
        </div>
      </section>
      <footer class="modal-card-foot">
        <a v-if="!done" class="button is-link" :class="{'is-loading': waiting}" :disabled="!valid" @click="createReceipts">
          {{(inbound && inbound.receipts.length) ? 'Recreate Item Receipts' : 'Create Item Receipts'}}
        </a>
        <a v-if="!done" class="button" @click="close">Cancel</a>
        <a v-if="done" class="button" @click="close">Close</a>
      </footer>
    </div>
  </div>
</template>
  
<script>

export default {
  name: 'create-item-receipts-modal',
  props: ['opened', 'inbound'],
  data () {
    return {
      error: '',
      waiting: false,
      receipts: [],
      done: false,
      deleting: false,
    }
  },
  computed: {
    server () {
      return this.$store.state.config.server
    },
    valid () {
      if (!this.receipts.length) {
        return false
      }
      return true
    },
    succeededReceipts () {
      if (!this.inbound || !this.inbound.receipts) {
        return []
      }
      return this.inbound.receipts.filter(r => Boolean(r.receiptId))
    },
  },
  watch: {
    opened: function (val) {
      if (val && this.inbound) {
        this.makeItemReceipts()
      }
    }
  },
  methods: {
    close () {
      this.$emit('closeCreateItemReceiptsModal', false)
    },
    makeItemReceipts () {
      var receiptsMap = {}
      var items = this.inbound.items.map(item => {
        var newItem = JSON.parse(JSON.stringify(item))
        var cc = item.containerInfo.split(',')
        var cq = {}
        for (var c of cc) {
          var ss = c.trim().split('(')
          var c = ss[0].trim()
          var qty = parseInt(ss[1].replaceAll(')', '').trim())
          if (!cq[c]) {
            cq[c] = 0
          }
          cq[c] += qty
        }
        var parts = []
        for (var c in cq) {
          parts.push(c + '(' + cq[c] + ')')
        }
        newItem.containerInfo = parts.join(', ')
        return newItem
      })
      items.forEach((item, index) => {
        var cc = item.containerInfo.split(',')
        for (var c of cc) {
          var ss = c.trim().split('(')
          var c = ss[0].trim()
          var qty = parseInt(ss[1].replaceAll(')', '').trim())
          var key = this.inbound.shipmentNumber + ':' + this.inbound.id + ':' + item.po.tranId + ':' + c
          var itemReceipt = receiptsMap[key]
          if (!itemReceipt) {
            itemReceipt = {
              key: key,
              inboundId: this.inbound.id,
              poId: item.poId,
              poNsId: item.po.nsId,
              poTranId: item.po.tranId,
              po: item.po,
              container: c,
              items: [],
              nsResult: {},
              quantity: 0,
              result: 'Pending',
            }
            receiptsMap[key] = itemReceipt
          }
          itemReceipt.quantity += qty
          itemReceipt.items.push({
            inboundItem: item,
            inboundItemIndex: index,
            qty: qty,
          })
        }
        console.log(receiptsMap)
        this.receipts = Object.values(receiptsMap)
      })
    },
    createReceipts () {
      if (this.waiting || !this.valid) {
        return
      }
      if (this.inbound.receipts.length) {
        var data = {
          inboundId: this.inbound.id,
          receipts: this.succeededReceipts.slice()
        }
        this.deleting = true
        this.$http.post(this.server + '/myapp/confirm-item-receipts-deleted/', data).then(resp => {
          this.deleting = false
          this.createReceipt(0)
        }, err => {
          this.error = 'Failed to confirm the previous item receipts deleted! ' + JSON.stringify(err.body) + ' You need to manually delete those previous item receipts above, and click this button again to recreate item receipts.'
          this.deleting = false
        })
      } else {
        this.createReceipt(0)
      }
    },
    createReceipt(index) {
      this.waiting = true
      var receipt = this.receipts[index]
      var message = {
        inboundId: this.inbound.id,
        key: receipt.key,
        poId: receipt.poId,
        poNsId: receipt.poNsId,
        poTranId: receipt.poTranId,
        container: receipt.container,
        items: receipt.items.map(item => {
          return {
            inboundItemId: item.inboundItem.id,
            itemId: item.inboundItem.itemId,
            poLine: item.inboundItem.poLine,
            shipmentItemName: item.inboundItem.shipmentItemName,
            shipmentItemDescription: item.inboundItem.shipmentItemDescription,
            shipmentItemId: item.inboundItem.shipmentItemId,
            quantity: item.qty,
            inboundItemIndex: item.inboundItemIndex,
          }
        })
      }
      receipt.result = 'Creating...'
      this.$http.post(this.server + '/myapp/create-item-receipt/', message).then(resp => {
        receipt.result = 'Succeeded'
        receipt.nsResult = resp.body
        if (index + 1 < this.receipts.length) {
          this.createReceipt(index + 1)
        } else {
          this.waiting = false
          this.done = true
          this.$emit('itemReceiptsCreated')
        }
      }, err => {
        receipt.result = 'Failed'
        if (index + 1 < this.receipts.length) {
          this.createReceipt(index + 1)
        } else {
          this.waiting = false
          this.done = true
          this.$emit('itemReceiptsCreated')
        }
      })
    },
    formatPrice (value) {
      if (!value) {
        return ''
      }
      return '$' + value.toLocaleString('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        useGrouping: false
      })
    },
  },
}
</script>

<style scoped>
.my-modal-card {
  width: 80%!important;
}
</style>